<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          گزارش مانده حساب واحدها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="closed">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col cols="12" md="8">
            <v-row>
              <v-col
                  cols="12"
                  md="4">
                <v-autocomplete
                    :items="buildingList"
                    v-model="params.buildingId"
                    @change="onChangeBuilding"
                    dense
                    outlined
                    :error-messages="getError('buildingId')"
                    auto-select-first append-icon="fas fa-angle-down"
                    label="انتخاب مجتمع"

                />

              </v-col>
              <v-col
                  cols="12"
                  md="4">
                <v-autocomplete
                    :items="blocksItems"
                    v-model="params.blocks"
                    outlined
                    dense
                    chips
                    :error-messages="getError('blocks')"
                    small-chips
                    label=" انتخاب بلوک ها"
                    multiple
                >
                  <template v-slot:prepend-item>
                    <v-checkbox
                        :indeterminate="params.blocks && params.blocks.length>0 && params.blocks.length<blocksItems.length"
                        v-model="selectAll"
                        label="انتخاب همه "
                        @click="select_All_Block"
                    />
                  </template>


                  <template v-slot:selection="{ item, index }">
                    <!--                    <v-chip v-if="index === 0">-->
                    <span v-if="index === 0">{{ item.text }}</span>
                    <!--                    </v-chip>-->
                    <span
                        v-if="index === 1"
                        class="grey--text caption"
                    >
          (+{{ params.blocks.length - 1 }} دیگر)
        </span>
                  </template>


                </v-autocomplete>


              </v-col>
              <v-col
                  cols="12"
                  md="4">
                <date-picker placeholder=" تاریخ" v-model="params.toDate" color="#3b5694" clearable
                             auto-submit>

                </date-picker>
                <span style="color: red" v-if="getError('toDate')" v-text="getError('toDate')"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>

              <v-col cols="12" md="3" class="p-0 m-0" v-for="acc in accountTypeItem" :key="acc.value">
                <v-checkbox
                    :error-messages="getError('accounts')"
                    v-model="acc.check"
                    :label="acc.text"
                ></v-checkbox>
              </v-col>

              <v-col
                  cols="12"
                  md="3" class="d-inline-flex">
                <v-btn small fab color="primary" @click="search">
                  <v-icon>mdi-cloud-search</v-icon>
                </v-btn>
                <v-btn v-if="dataItems && dataItems.length>0" class="mr-1" small fab color="error" @click="createPdf">
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="dataItems && dataItems.length>0" class="mr-1" small fab color="success"
                       @click="reportExcel">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>


              </v-col>
            </v-row>
          </v-col>


        </v-row>


        <v-spacer/>
      </v-card-text>
      <!-- کادر فیلتر بالای جدول -->
      <v-card class="mb-3 mx-2" outlined v-if="dataItems && dataItems.length > 0">
        <PageEdit :dialog-status.sync="dialog" :template-items="templateItems" :data-list="filteredItems"
                  :cost="cost" :date="params.toDate" :model="model" :credit-balance="creditBalance"
                  :building-name="buildingName" :user-items="userItems" :building-id="buildingId"/>
        <v-card-title class="py-2">
          <div class="d-flex align-center">
            <v-icon class="mr-2" small>mdi-filter-variant</v-icon>
            <span class="subtitle-2 font-weight-medium">فیلتر</span>
          </div>

          <v-spacer></v-spacer>


          <v-chip

              v-if="filteredItems"
              large
              label
              outlined
              class="ml-2"
          >
            {{ filteredItems.length }} نتیجه
          </v-chip>
        </v-card-title>


        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-text-field
                  outlined
                  dense
                  class="custom-font-input"
                  hide-details
                  label="از مبلغ"
                  v-model="formattedDebtorFrom"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                  outlined
                  dense
                  class="custom-font-input"
                  hide-details
                  label="تا مبلغ"
                  v-model="formattedDebtorTo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                  :disabled="filteredItems.length===0"
                  outlined
                  block
                  color="warning"
                  @click="sendSms"
              >
                ارسال پیام
              </v-btn>
            </v-col>

            <v-col cols="12" md="3" class="d-flex align-center justify-end">


              <v-btn
                  text
                  small
                  color="grey darken-1"
                  @click="debtorFrom = null; debtorTo = null"
              >
                پاک کردن فیلتر
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card-text>
        <b-table
            v-if="isMobile"
            responsive
            striped
            hover
            stacked="md"
            :items="filteredItems"
            :fields="columns"
            show-empty
        />
        <b-table
            v-else
            sticky-header="400px"
            striped
            hover
            :items="filteredItems"
            :fields="columns"
            show-empty>
          <template v-slot:bottom-row>
            <td style="border: none!important;"><strong>مجموع</strong></td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>

            <td style="border: none!important;">
              <strong>
                <strong v-if="formattedTotalDebtor && formattedTotalDebtor.includes('-')"
                        style="color: red">{{ formattedTotalDebtor }} </strong>
                <strong
                    v-if="formattedTotalDebtor && !formattedTotalDebtor.includes('-')">{{ formattedTotalDebtor }} </strong>

              </strong>

            </td>
            <td style="border: none!important;">
              <strong>
                <strong v-if="formattedTotalCreditor && formattedTotalCreditor.includes('-')"
                        style="color: red">{{ formattedTotalCreditor }} </strong>
                <strong
                    v-if="formattedTotalCreditor && !formattedTotalCreditor.includes('-')">{{ formattedTotalCreditor }} </strong>

              </strong>

            </td>


          </template>
        </b-table>

      </v-card-text>
      <VueHtml2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :paginate-elements-by-height="600"
          :manual-pagination="true"
          filename="filename"
          :pdf-quality="2"

          pdf-format="a4"
          :html-to-pdf-options="htmlToPdfOptions"
          ref="html2Pdf">

        <section slot="pdf-content">

          <div class="container-fluid" style="direction: rtl">
            <!--          header-->
            <header class="report-header">
              <div class="header-left">


              </div>
              <div class="header-center">
                <div class="report-title">
                  گزارش مانده حساب واحدهای مجتمع {{ buildingName }}
                </div>
              </div>
              <div class="header-right">
                <div class="account-types">
        <span v-for="acc in accountTypeItem" :key="acc.value" class="account-type-item">
          <input
              type="checkbox"
              :id="acc.value"
              :name="acc.value"
              :value="acc.check"
              v-model="acc.check"
          >
          <label :for="acc.value">{{ acc.text }}</label>
        </span>
                </div>
                <div class="report-date">
                  <span class="text-muted">تا تاریخ :</span> {{ nowDate }}
                </div>
                <!-- اگر محتوای دیگری در سمت راست دارید، اینجا قرار دهید -->
              </div>
            </header>
            <!--          header-->
            <!--          body-->
            <form v-for="(items,j) in pdfItems" :key="j">
              <section class="pdf-item">
                <div class="container-fluid">
                  <div class="row p-2" style="margin-top: 20px">
                    <div class="col-12">
                      <table id="myTable">
                        <thead>
                        <tr class="header">
                          <th class="text-right">ردیف</th>
                          <th class="text-right">عنوان واحد</th>
                          <th class="text-right">نام مالک</th>
                          <th class="text-right">شماره مالک</th>
                          <th class="text-right">نام مستاجر</th>
                          <th class="text-right">شماره مستاجر</th>
                          <th class="text-right"> مانده بدهکار</th>
                          <th class="text-right"> مانده بستانکار</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item ,i) in items" :key="i">
                          <td class="text-right">{{ (i + 1) + (25 * j) }}</td>
                          <td class="text-right">{{ item.unitName }}</td>
                          <td class="text-right">{{ item.ownerName }}</td>
                          <td class="text-right">{{ item.ownerPhone }}</td>
                          <td class="text-right">{{ item.tenantName }}</td>
                          <td class="text-right">{{ item.tenantPhone }}</td>
                          <td class="text-right">{{ formatToPersian(item.remainingDebtor) }}</td>
                          <td class="text-right">{{ formatToPersian(item.remainingCreditor) }}</td>
                        </tr>
                        <tr v-if="j === pdfItems.length - 1">
                          <td style="border: none!important;"><strong>مجموع</strong></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;">
                            <strong>
                              <strong v-if="formattedTotalDebtor && formattedTotalDebtor.includes('-')"
                                      style="color: red">{{ formattedTotalDebtor }} </strong>
                              <strong
                                  v-if="formattedTotalDebtor && !formattedTotalDebtor.includes('-')">{{ formattedTotalDebtor }} </strong>

                            </strong>
                          </td>
                          <td style="border: none!important;">
                            <strong>
                              <strong v-if="formattedTotalCreditor && formattedTotalCreditor.includes('-')"
                                      style="color: red">{{ formattedTotalCreditor }} </strong>
                              <strong
                                  v-if="formattedTotalCreditor && !formattedTotalCreditor.includes('-')">{{ formattedTotalCreditor }} </strong>

                            </strong>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </section>
              <v-spacer/>
              <div class="html2pdf__page-break"/>

            </form>

            <!--          body-->
          </div>

        </section>
      </VueHtml2pdf>
    </v-card>

  </div>
</template>

<script>
import Service from "./Service";
import PageEdit from "./PageEdit.vue";
import {mapMutations} from "vuex";
import VueHtml2pdf from 'vue-html2pdf'
// import persianDate from 'persian-date'

export default {

  name: 'RemainingReport',
  components: {
    VueHtml2pdf,
    PageEdit
  },
  data() {
    return {
      isMobile: window.innerWidth < 768,
      buildingList: [],
      blocksItems: [],
      accountTypeItem: [],
      templateItems: [],
      userItems: [],
      fieldItems: [
        {value: 'unitName', text: 'عنوان واحد'},
        {value: 'ownerName', text: 'نام مالک',},
        {value: 'tenantName', text: 'نام مستاجر',},
        {value: 'remainingDebtor', text: 'مانده بدهکار'},
        {value: 'remainingCreditor', text: 'مانده بستانکار'},
        {value: 'date', text: 'تاریخ'},
      ],
      params: {},
      cost: 0,
      debtorFrom: '',
      debtorTo: '',
      buildingName: '',
      creditBalance: 0,
      buildingId: '',
      selectAll: false,
      dialog: false,
      dataItems: [],
      pdfItems: [],
      bindingErrors: [],
      model: {},
      nowDate: '',
      columns: [
        {key: 'index', label: 'ردیف', formatter: (value, key, item) => this.filteredItems.indexOf(item) + 1},
        {key: 'unitName', label: 'عنوان واحد', sortable: true, sortDirection: 'desc'},
        {key: 'ownerName', label: 'نام مالک',},
        {key: 'ownerPhone', label: 'شماره مالک',},
        {key: 'tenantName', label: 'نام مستاجر',},
        {key: 'tenantPhone', label: 'شماره مستاجر',},
        {
          key: 'remainingDebtor',
          label: 'مانده بدهکار',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value) => this.formatToPersian(value)
        },
        {
          key: 'remainingCreditor',
          label: 'مانده بستانکار',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value) => this.formatToPersian(value)
        },

      ],

      htmlToPdfOptions: {
        margin: [2, 2, 2, 2],
      }

    };

  },
  mounted() {
    this.$root.$on('reset_all_dialogs_sms', () => {
      // your code goes here
      this.resetReportRem()
    })
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    closed() {
      this.params = {}
      this.dataItems = []
      this.$router.push('/home')
    },
    checkScreen() {
      this.isMobile = window.innerWidth < 768;
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput(value) {
      this.$emit('input', value)
    },
    sendSms() {
      Service.getTemplateSms(this.params.buildingId).then(response => {
        this.templateItems = response.data.list
        this.creditBalance = response.data.creditBalance
        this.cost = response.data.cost
        this.buildingName = this.buildingList.filter(b => b.value === this.params.buildingId)[0].text
        this.buildingId = this.params.buildingId
        this.getUsers()
        this.dialog = true
      })


    },
    onChangeBuilding() {
      this.buildingName = this.buildingList.filter(b => b.value === this.params.buildingId)[0].text
      Service.getBuildingItems(this.params.buildingId).then(response => {
        this.blocksItems = response.data.blocksItems
        this.accountTypeItem = response.data.accountTypeItem
      })
    },
    resetReportRem() {
      this.debtorFrom = ''
      this.debtorTo = ''
      this.params = {}
      this.model = {}
      this.dataItems = []
      this.pdfItems = []
      this.formattedDebtorFrom = ''
      this.formattedDebtorTo = ''
      this.blocksItems =[]
      this.accountTypeItem = []
      this.templateItems = []
      this.userItems = []
      this.selectAll=false
      this.dialog=false
      this.fillDataItems()
    },
    fillDataItems() {
      this.debtorFrom = ''
      this.debtorTo = ''
      this.params = {}
      Service.getPage().then(response => {
        this.buildingList = response.data.buildingList
        this.params = response.data.params
        this.model = response.data.model

      });
    },
    createPdf() {
      this.$refs.html2Pdf.generatePdf()
    },
    reportExcel() {
      this.params.isExcel = true
      Service.reportExcel(this.params).then(response => {
        this.loading = false;
        if (response && response.status === 200) {

          let blob = new Blob([response.data],
              {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
          let url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = new Date() + '.xlsx'; // نام فایل
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url); // آزادسازی حافظه blob

        } else if (response && response.response.status === 400) {
          this.loading = false;
          this.bindingErrors = response.response.data;
          console.log(this.bindingErrors)
        }
      })
    },
    select_All_Block() {
      this.params.blocks = [];
      if (this.selectAll) {
        for (let item in this.blocksItems) {
          this.params.blocks.push(this.blocksItems[item].value);
        }
      }
    },
    search() {
      this.dataItems = []
      this.bindingErrors = []
      this.params.accounts = this.accountTypeItem
          .filter(acc => acc.check)
          .map(acc => acc.value);
      this.$progress({message: 'درحال جستجو...'}, true)
      Service.search(this.params).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data.outList
          this.pdfItems = response.data.pdfList
          this.nowDate = this.params.toDate
        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })
    },
    formatToPersian(value) {
      if (typeof value !== 'number' && typeof value !== 'string') return value;
      try {
        // از Intl.NumberFormat برای تبدیل استاندارد استفاده می‌کنیم
        return new Intl.NumberFormat("fa-IR", {
          maximumFractionDigits: 20 // برای نمایش کامل اعداد اعشاری
        }).format(Number(value));
      } catch (e) {
        console.error("Error formatting number:", e);
        return value.toLocaleString(); // در صورت خطا، مقدار اصلی را برگردان
      }
    },
    toNumber(v) {
      if (v === null || v === undefined || v === '') return null
      // حذف کاما و تبدیل به عدد
      const n = Number(String(v).replaceAll(',', '').trim())
      return Number.isFinite(n) ? n : null
    },
    /**
     * get name of  owner or tenant
     */
    getUsers() {
      this.userItems = [];

      const existsMonthly = this.accountTypeItem.find(x => x.value === 'monthly')?.check;
      const existsConstruction = this.accountTypeItem.find(x => x.value === 'construction')?.check;

      const addedPhones = new Set();
      // متد اضافه کردن کاربر
      const addUser = (name, phone, role) => {
        if (!name || !phone || addedPhones.has(phone)) return;

        this.userItems.push({
          text: name,
          value: phone,
          value1: role
        });

        addedPhones.add(phone);
      };
// حلقه for
      this.filteredItems.forEach(item => {
        if (existsConstruction) {
          addUser(item.ownerName, item.ownerPhone, 'OWNER');
        }

        if (existsMonthly) {
          if (item.tenantName && item.tenantPhone) {
            addUser(item.tenantName, item.tenantPhone, 'TENANT');
          } else {
            addUser(item.ownerName, item.ownerPhone, 'TENANT');
          }
        }
      });
    },


  },
  computed: {
    formattedDebtorFrom: {
      get() {
        // تبدیل عدد به فرمت سه رقم جدا شده
        return this.debtorFrom ? this.debtorFrom.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      },
      set(val) {
        // پاک کردن جداکننده ها هنگام ذخیره در متغیر اصلی
        this.debtorFrom = val.replace(/,/g, '');
      }
    },
    formattedDebtorTo: {
      get() {
        // تبدیل عدد به فرمت سه رقم جدا شده
        return this.debtorTo ? this.debtorTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      },
      set(val) {
        // پاک کردن جداکننده ها هنگام ذخیره در متغیر اصلی
        this.debtorTo = val.replace(/,/g, '');
      }
    },
    rawTotalDebtor() {
      return this.dataItems.reduce((sum, item) => {
        const remainingDebtor = Number(item.remainingDebtor);
        return sum + (isNaN(remainingDebtor) ? 0 : remainingDebtor);
      }, 0);
    },
    // فرمت کردن مجموع
    formattedTotalDebtor() {
      return this.formatToPersian(this.rawTotalDebtor); //
    },
    rawTotalCreditor() {
      return this.dataItems.reduce((sum, item) => {
        const remainingCreditor = Number(item.remainingCreditor);
        return sum + (isNaN(remainingCreditor) ? 0 : remainingCreditor);
      }, 0);
    },

    // فرمت کردن مجموع
    formattedTotalCreditor() {
      return this.formatToPersian(this.rawTotalCreditor); //
    },
//فیلتر کردن دادهای جدول
    filteredItems() {
      const from = this.toNumber(this.formattedDebtorFrom)
      const to = this.toNumber(this.formattedDebtorTo)
      return (this.dataItems || []).filter(item => {
        const val = this.toNumber(item.remainingDebtor)

        if (from !== null && val < from) return false
        if (to !== null && val > to) return false
        return true
      })
    }
  },
  watch: {
    '$route'() {
      // هر وقت صفحه تغییر کرد، داده‌ها را دوباره بگیر
      this.fillDataItems();
    }
  },
  created() {
    this.fillDataItems()
    this.setDrawer(false)
  }


}
</script>
<style src="@/assets/styles/pdfReportStyles.css"></style>
<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
<style scoped>
.custom-font-input ::v-deep .v-text-field__slot input {
  font-size: 16px !important;
//font-weight: bold !important;
}


</style>
